import {requestInstance} from "@/app/[locale]/config/requestInstance";
import CityModel from "@/app/services/models/CityModel";

class CityService {
    api = {
        main: '/cities'
    }

    params = {
        search: "search=",
    };

    getCitiesByCountryId(countryId, query = '') {
        const queryParam = `?${this.params.search}${query}`;
        return requestInstance.get(`${this.api.main}/${countryId}${queryParam}`)
            .then(r => r?.data.map(item => new CityModel(item)))
            .catch(error => Promise.reject(error));
    }
}

export const cityService = new CityService();